import { useEffect, useLayoutEffect, useRef } from 'react'

export function useListenerMessage(onData: (data: string) => void) {
  const memoizedFunction = useRef(onData)

  useLayoutEffect(() => {
    memoizedFunction.current = onData
  }, [onData])

  useEffect(() => {
    const handler = (event: Event) => {
      const typedEvent = event as Event & { data: string }
      if (typedEvent.data) {
        memoizedFunction.current(typedEvent.data)
      }
    }

    if (navigator.appVersion.includes('Android')) {
      document.addEventListener('message', handler)
      return () => document.removeEventListener('message', handler)
    } else {
      window.addEventListener('message', handler)
      return () => window.removeEventListener('message', handler)
    }
  }, [])
}
